export interface WopiDiscoveryInfo {
	ActionUrl:string;
	AccessTokenTtl:number;
	FaviconUrl:string;
	TokenStr:string;
}

export enum WopiFileType {
	OpenDocSpreadSheet = 'ods',
	OpenDocPresentation = 'odp',
	OpenDocText = 'odt',
	Excel = 'xlsx',
	ExcelBinary = 'xlsb',
	ExcelLegacy = 'xls',
	ExcelMacro = 'xlsm',
	OneNote = 'one',
	OneNotePackage = 'onepkg',
	OneNoteTableOfContents = 'onetoc2',
	PowerpointTemplate = 'potx',
	PowerPointTemplateLegacy = 'pot',
	PowerPointTemplateMacro = 'potm',
	PowerPointSlideShow = 'ppsx',
	PowerPointSlideShowLegacy = 'pps',
	PowerPointSlideShowMacro = 'ppsm',
	PowerPointPresentation = 'pptx',
	PowerPointPresentationLegacy = 'ppt',
	PowerPointPresentationMacro = 'pptm',
	VisioDrawing = 'vsdx',
	VisioDrawingLegacy = 'vsd',
	VisioDrawingMacro = 'vsdm',
	Word = 'docx',
	WordLegacy = 'doc',
	WordMacro = 'docm',
	WordTemplate = 'dotx',
	WordTemplateLegacy = 'dot',
	WordTemplateMacro = 'dotm',
	RichTextFormat = 'rtf',
	PortableDocumentFormat = 'pdf',
	BASICSource = 'b',
	WopiTest = 'wopitest'
}

export const EditableWopiFiles = new Set<string>([
	WopiFileType.OpenDocSpreadSheet,
	WopiFileType.OpenDocText,
	WopiFileType.OpenDocPresentation,
	WopiFileType.Excel,
	WopiFileType.ExcelBinary,
	WopiFileType.ExcelMacro,
	WopiFileType.PowerPointSlideShow,
	WopiFileType.PowerPointPresentation,
	WopiFileType.Word,
	WopiFileType.WordMacro,
	WopiFileType.WopiTest
]);



// WEBPACK FOOTER //
// ./src/phoenix/domain/wopi.ts